import React from 'react';
import { Card, CardContent, Typography, Box } from '@mui/material';
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';

interface PostTypeDistribution {
  NORMAL: number;
  JOURNAL: number;
  REPORT: number;
  [k: string]: number;
}

const COLORS = ['#1976d2', '#2e7d32', '#ed6c02'];
const LABELS: Record<string, string> = {
  NORMAL: '일반 게시물',
  JOURNAL: '낚시 일지',
  REPORT: '조황 리포트',
};

const PostTypeDistributionChart: React.FC<{ data: PostTypeDistribution }> = ({ data }) => {
  const chartData = Object.entries(data)
    .filter(([, v]) => (v ?? 0) > 0)
    .map(([type, count]) => ({ name: LABELS[type] || type, value: count }));

  return (
    <Card sx={{ flex: '1 1 300px', minWidth: 0 }}>
      <CardContent>
        <Typography variant="h6" sx={{ mb: 2 }}>
          게시물 타입 분포
        </Typography>
        <Box sx={{ width: '100%', height: 260 }}>
          {chartData.length === 0 ? (
            <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', pt: 8 }}>
              게시물이 아직 없습니다.
            </Typography>
          ) : (
            <ResponsiveContainer>
              <PieChart>
                <Pie
                  data={chartData}
                  dataKey="value"
                  nameKey="name"
                  cx="50%"
                  cy="50%"
                  outerRadius={80}
                  innerRadius={40}
                  paddingAngle={2}
                  label={({ percent }) => `${(percent! * 100).toFixed(0)}%`}
                  labelLine={false}
                >
                  {chartData.map((_, idx) => (
                    <Cell key={idx} fill={COLORS[idx % COLORS.length]} />
                  ))}
                </Pie>
                <Tooltip />
                <Legend verticalAlign="bottom" height={36} />
              </PieChart>
            </ResponsiveContainer>
          )}
        </Box>
      </CardContent>
    </Card>
  );
};

export default PostTypeDistributionChart;
